// extracted by mini-css-extract-plugin
export default {"inner_white":"PageWrapper_inner_white__1IhP8"};